import { Grid, Typography } from "@mui/material"
import React, { useMemo } from "react"
import { customPalette } from "../../../../../../../../../../theme"
import { BimModelChart } from "../../../../../../../../../components/charts/BimModelChart/BimModelChart"
import { ImpactKPI } from "../../../../../../../../../components/charts/kpi/ImpactKPI"
import { IcConstructionThresholdChart } from "../../../../../../../../../components/charts/ThresholdChart/IcConstructionThresholdChart"
import { BSBuilding } from "../../../../../../../../../core/dto/beem-shot/BSBuilding/BSBuilding"
import { BSBuildingResult } from "../../../../../../../../../core/dto/beem-shot/BSBuildingResult/BSBuildingResult"
import { BSMaterialResultDashboard } from "../../../../../../../../../core/dto/beem-shot/BSMaterialResult/BSMaterialResultDashboard"
import { BSMorphology } from "../../../../../../../../../core/dto/beem-shot/BSMorphology/BSMorphology"
import { computeLabelIsRE2020 } from "../../../../../../../../../core/services/Dashboard/DashboardService"

interface IProps {
  bsBuilding: BSBuilding | undefined
  bsBuildingResult: BSBuildingResult | undefined
  bsMaterialResultList: BSMaterialResultDashboard[]
  maxValue: number
  bsMorphology: BSMorphology | undefined
  bimModelFile: File | undefined
}

export function BuildingThresholdRow({
  bsBuilding,
  bsBuildingResult,
  maxValue,
  bsMaterialResultList,
  bsMorphology,
  bimModelFile,
}: Readonly<IProps>): React.JSX.Element {
  const labelIsRE20201: string = useMemo(
    () => (bsBuildingResult ? computeLabelIsRE2020(bsBuildingResult) : ""),
    [bsBuildingResult]
  )

  return bsBuilding && bsBuildingResult ? (
    <Grid container item xs={6}>
      <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
        <Typography>{bsBuilding.name}</Typography>
      </Grid>
      <Grid container item xs={12} alignItems="center" height={150}>
        <Grid item xs={3} container spacing={2}>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <ImpactKPI
              carbonImpact={bsBuildingResult.carbonImpactTotalPerSurface}
              unit={
                <span>
                  (kgeqCO<sub>2</sub>/m²Sref)
                </span>
              }
            />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
            <Typography textAlign="center" sx={{ fontWeight: "bold", color: customPalette.dashboardGray }}>
              {labelIsRE20201}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={7} sx={{ display: "flex", alignItems: "center" }}>
          <IcConstructionThresholdChart
            impact={bsBuildingResult.carbonImpactTotalPerSurface}
            threshold2022={bsBuildingResult.threshold2022}
            threshold2025={bsBuildingResult.threshold2025}
            threshold2028={bsBuildingResult.threshold2028}
            threshold2031={bsBuildingResult.threshold2031}
            maxValue={maxValue}
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <BimModelChart
          allBSMaterialResult={bsMaterialResultList}
          bSBuilding={bsBuilding}
          bsMorphology={bsMorphology}
          bimModelFile={bimModelFile}
        />
      </Grid>
    </Grid>
  ) : (
    <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
      <Typography>Il faut lancer le calcul de l'estimation sur ce bâtiment.</Typography>
    </Grid>
  )
}
